"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var grid_1 = require("@rebass/grid");
var marked = __importStar(require("marked"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Column_1 = require("./Layout/Column");
var Text = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: white;\n  a {\n    color: #b4a689;\n  }\n"], ["\n  color: white;\n  a {\n    color: #b4a689;\n  }\n"])));
var Column = styled_components_1["default"](grid_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 28px;\n"], ["\n  padding: 0 28px;\n"])));
var GetWidth = function (width) {
    if (width === "Fourth") {
        return 1 / 4;
    }
    if (width === "Third") {
        return 1 / 3;
    }
    if (width === "Half") {
        return 1 / 2;
    }
    if (width === "Full") {
        return 1;
    }
};
exports.TextColumn = function (props) {
    return (React.createElement(Column, { width: [1, props.blok.Width ? GetWidth(props.blok.Width) : 1 / 4] },
        React.createElement(Column_1.ColumnHeader, null, props.blok.Header),
        React.createElement(Text, { dangerouslySetInnerHTML: { __html: marked["default"](props.blok.Text) } })));
};
var templateObject_1, templateObject_2;
